export default "__VITE_ASSET__p1G80U_8__"